import { debounce } from '../utility-functions/utility-functions';
import { getCookie, setCookie } from '../cookies/cookies';
import { isMobile } from '../mobile-detect/mobile-detect';

export const initMobileProductGrid = (): void => {
    const productGridView = document.querySelector<HTMLElement>('.product-grid_view');
    const productGrid = document.querySelector<HTMLElement>('.listing .product-grid');

    if (productGridView && productGrid) {
        productGridView.addEventListener('click', () => {
            productGrid.classList.toggle('product-grid--single');

            const newValue = getCookie('product-grid-columns') === "1" ? "2" : "1";
            setCookie('product-grid-columns', newValue, 365);

            const productGridViewItems = productGridView.querySelectorAll<HTMLElement>('.product-grid_view-item');
            mobileProductGridLayoutIcons(productGridViewItems);
        });
    }

    // Run initial layout setup
    mobileProductGridLayout();

    // Re-run layout setup on resize (but don't re-bind click event)
    window.addEventListener("resize", debounce(() => mobileProductGridLayout()));
};

export const mobileProductGridLayout = (): void => {
    if (isMobile()) {
        const productGrid = document.querySelector('.listing .product-grid') as HTMLElement | null;
        if (!productGrid) return;

        // Set layout based on cookie
        if (getCookie('product-grid-columns') === "1") productGrid.classList.add('product-grid--single');
        else productGrid.classList.remove('product-grid--single');

        const productGridView = document.querySelector<HTMLElement>('.product-grid_view');
        if (!productGridView) return;

        const productGridViewItems = productGridView.querySelectorAll<HTMLElement>('.product-grid_view-item');
        mobileProductGridLayoutIcons(productGridViewItems);
    }
};

const mobileProductGridLayoutIcons = (productGridViewItems: NodeListOf<HTMLElement>): void => {
    productGridViewItems.forEach((item: HTMLElement) => {
        const isSingle = getCookie('product-grid-columns') === "1";

        const iconActive = item.querySelector<HTMLElement>('.icon_active');
        const iconDefault = item.querySelector<HTMLElement>('.icon_default');

        if (!iconActive || !iconDefault) return;

        const isSingleItem = item.classList.contains('js-product-grid_view-item--single');
        const isMultiItem = item.classList.contains('js-product-grid_view-item--multi');

        if (isSingle) {
            if (isSingleItem) {
                iconActive.classList.remove('d-none');
                iconDefault.classList.add('d-none');
            } else if (isMultiItem) {
                iconActive.classList.add('d-none');
                iconDefault.classList.remove('d-none');
            }
        } else {
            if (isSingleItem) {
                iconActive.classList.add('d-none');
                iconDefault.classList.remove('d-none');
            } else if (isMultiItem) {
                iconActive.classList.remove('d-none');
                iconDefault.classList.add('d-none');
            }
        }
    });
};
